<mat-toolbar class="h-100 w-100">

    <div class="d-flex flex-column justify-content-start align-items-center h-100 w-100 py-2">

        <div class="d-flex flex-column flex-md-row justify-content-center justify-content-lg-center align-items-center w-100">

            <a [href]="urlPartner" target="_blank">
                <img class="logo-partner me-4" [src]="logoPatner"></a>

            <a [href]="urlFSS" target="_blank">
                <img class="logo-fss mt-3 mt-sm-2 mt-md-0" [src]="logoFSS"></a>

        </div>

        <div class="d-flex flex-row justify-content-center align-items-center w-100 pt-3">
            <small class="">© {{ campusYear }}. Todos los derechos reservados.</small>
        </div>

    </div>

</mat-toolbar>
